export default {
  addProduct: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005C7","新增商品") /* "新增商品" */,
  productName: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005C8","商品名称") /* "商品名称" */,
  productCode: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005C9","商品编码") /* "商品编码" */,
  productProperty: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005CA","商品属性") /* "商品属性" */,
  price: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005CB","价格") /* "价格" */,
  danwei: lang.templateByUuid("UID:P_UDHWN_17DD50DE050005CC","单位") /* "单位" */
};
